import _taggedTemplateLiteral from '../node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js';
import styled, { css } from 'styled-components';

var _templateObject, _templateObject2, _templateObject3;

// code themes are taken from highlight js package to allow code highlight styles based on the active theme for the component
// snapshot tests for highlight.utils.js ensure hljs class names are applied as expected with these themes
const lightCodeTheme = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  pre code.hljs {\n    display: block;\n    overflow-x: auto;\n    padding: 1em;\n  }\n  code.hljs {\n    padding: 3px 5px;\n  }\n  .hljs {\n    background: #fff;\n    color: #000;\n  }\n  .hljs-comment,\n  .hljs-quote,\n  .hljs-variable {\n    color: green;\n  }\n  .hljs-built_in,\n  .hljs-keyword,\n  .hljs-name,\n  .hljs-selector-tag,\n  .hljs-tag {\n    color: #00f;\n  }\n  .hljs-addition,\n  .hljs-attribute,\n  .hljs-literal,\n  .hljs-section,\n  .hljs-string,\n  .hljs-template-tag,\n  .hljs-template-variable,\n  .hljs-title,\n  .hljs-type {\n    color: #7e1010;\n  }\n  .hljs-deletion,\n  .hljs-meta,\n  .hljs-selector-attr,\n  .hljs-selector-pseudo {\n    color: #247a94;\n  }\n  .hljs-doctag {\n    color: #707070;\n  }\n  .hljs-attr {\n    color: #e00000;\n  }\n  .hljs-bullet,\n  .hljs-link,\n  .hljs-symbol {\n    color: #007da3;\n  }\n  .hljs-emphasis {\n    font-style: italic;\n  }\n  .hljs-strong {\n    font-weight: 700;\n  }\n"])));
const darkCodeTheme = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  .hljs {\n    color: #c9d1d9;\n    background: #16191f;\n  }\n  .hljs-doctag,\n  .hljs-keyword,\n  .hljs-meta .hljs-keyword,\n  .hljs-template-tag,\n  .hljs-template-variable,\n  .hljs-type,\n  .hljs-variable.language_ {\n    color: #ff7b72;\n  }\n  .hljs-title,\n  .hljs-title.class_,\n  .hljs-title.class_.inherited__,\n  .hljs-title.function_ {\n    color: #d2a8ff;\n  }\n  .hljs-attr,\n  .hljs-attribute,\n  .hljs-literal,\n  .hljs-meta,\n  .hljs-number,\n  .hljs-operator,\n  .hljs-selector-attr,\n  .hljs-selector-class,\n  .hljs-selector-id,\n  .hljs-variable {\n    color: #79c0ff;\n  }\n  .hljs-meta .hljs-string,\n  .hljs-regexp,\n  .hljs-string {\n    color: #a5d6ff;\n  }\n  .hljs-built_in,\n  .hljs-symbol {\n    color: #ffa657;\n  }\n  .hljs-code,\n  .hljs-comment,\n  .hljs-formula {\n    color: #8b949e;\n  }\n  .hljs-name,\n  .hljs-quote,\n  .hljs-selector-pseudo,\n  .hljs-selector-tag {\n    color: #7ee787;\n  }\n  .hljs-subst {\n    color: #c9d1d9;\n  }\n  .hljs-section {\n    color: #4388ef;\n    font-weight: 700;\n  }\n  .hljs-bullet {\n    color: #f2cc60;\n  }\n  .hljs-emphasis {\n    color: #c9d1d9;\n    font-style: italic;\n  }\n  .hljs-strong {\n    color: #c9d1d9;\n    font-weight: 700;\n  }\n  .hljs-addition {\n    color: #aff5b4;\n    background-color: #033a16;\n  }\n  .hljs-deletion {\n    color: #ffdcd7;\n    background-color: #67060c;\n  }\n"])));
const MarkdownContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: 'Amazon Ember', Helvetica, Arial, sans-serif;\n  background: ", ";\n  color: ", ";\n  color-scheme: ", ";\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    color: ", ";\n  }\n\n  p,\n  ul,\n  ol {\n    color: ", ";\n  }\n\n  img {\n    margin: 1.2rem auto;\n    max-width: 80%;\n  }\n\n  a {\n    color: ", ";\n    text-decoration: underline;\n    text-decoration-thickness: 1px;\n    text-underline-offset: 0.25em;\n\n    :hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n\n  & ::selection {\n    background-color: ", ";\n  }\n\n  blockquote {\n    border-collapse: collapse;\n    border-left: 10px solid ", ";\n    margin: 1.5rem 0;\n    padding: 0.25rem 0.25rem;\n    padding-left: 1rem;\n    background-color: ", ";\n  }\n\n  table {\n    border-collapse: collapse;\n    overflow-x: auto;\n    white-space: nowrap;\n    display: block;\n    margin: 1rem 0;\n    tbody {\n      background-color: ", ";\n    }\n    th,\n    tbody {\n      border: 1px solid ", ";\n    }\n    th {\n      background-color: ", ";\n      border-bottom: 1px solid ", ";\n      color: ", ";\n      padding: 1rem;\n      padding-right: 2rem;\n      padding-left: 1rem;\n    }\n    td {\n      color: ", ";\n      border-bottom: 1px solid ", ";\n      padding: 1rem;\n      padding-right: 2rem;\n      padding-left: 1rem;\n    }\n  }\n\n  li {\n    margin: 0.5rem 0 !important;\n  }\n\n  h1,\n  h2,\n  h3 {\n    padding: 0.5rem 0;\n    font-weight: 700;\n  }\n\n  h1 {\n    font-size: 2.8rem;\n    line-height: 3rem;\n    margin: 0;\n  }\n\n  h2 {\n    font-size: 2rem;\n    line-height: 2.4rem;\n  }\n\n  h3 {\n    font-size: 1.8rem;\n    line-height: 2.2rem;\n  }\n\n  kbd {\n    font-family: Lato, Helvetica Neue, Helvetica, sans-serif;\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n\n    // border radius\n    -webkit-border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    -moz-background-clip: padding;\n    -webkit-background-clip: padding-box;\n    background-clip: padding-box;\n\n    // box shadow\n    -webkit-box-shadow: 0 1px 0 ", ";\n    -moz-box-shadow: 0 1px 0 ", ";\n    box-shadow: 0 1px 0 ", ";\n\n    display: inline-block;\n    font-size: 0.8em;\n    margin: 0 0.1em;\n    padding: 0.1em 0.6em;\n    white-space: nowrap;\n  }\n\n  iframe,\n  div[class^='video-js '] {\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    max-width: 550px;\n    aspect-ratio: 16/9;\n  }\n\n  // Custom styles to override Polaris ExpandableSection component styles\n  // See ticket for context: https://sim.amazon.com/issues/EventHorizon-2611\n  .bork-expandable {\n    &-content {\n      padding: 0;\n      border-bottom-right-radius: ", ";\n      border-bottom-left-radius: ", ";\n\n      > :first-child {\n        margin-top: 0px;\n      }\n\n      > :last-child {\n        margin-bottom: 0px;\n      }\n    }\n\n    div[class^='awsui_header-container'],\n    div[class*=' awsui_header-container'] {\n      background-color: ", ";\n      border-radius: ", " !important;\n    }\n\n    div[class^='awsui_trigger'],\n    div[class*=' awsui_trigger'] {\n      h3 {\n        text-transform: none;\n      }\n\n      color: ", " !important;\n      &:hover {\n        color: ", " !important;\n      }\n    }\n\n    div[class^='awsui_trigger-expanded'],\n    div[class*=' awsui_trigger-expanded'] {\n      border-bottom-color: ", " !important;\n    }\n\n    // container varient style overrides\n    &--container {\n      background-color: ", " !important;\n      border-top: ", " !important;\n      box-shadow: ", " !important;\n      margin-bottom: ", " !important;\n\n      &-content {\n        background: ", ";\n        padding: 20px;\n        border-radius: ", ";\n\n        > :first-child {\n          margin-top: 0px;\n        }\n\n        > :last-child {\n          margin-bottom: 0px;\n        }\n      }\n\n      div[class^='awsui_wrapper-expanded']:first-child,\n      div[class*=' awsui_wrapper-expanded']:first-child {\n        border-bottom-right-radius: 0px !important;\n        border-bottom-left-radius: 0px !important;\n      }\n\n      div[class^='awsui_header-container'],\n      div[class*=' awsui_header-container'] {\n        border-radius: ", " !important;\n      }\n\n      > div[class^='awsui_header']:first-child,\n      > div[class*=' awsui_header']:first-child {\n        border-bottom: 1px solid\n          ", " !important;\n      }\n\n      > div[class^='awsui_trigger']:first-child,\n      > div[class*=' awsui_trigger']:first-child {\n        border-bottom: 0px !important;\n      }\n    }\n  }\n\n  // Custom styles to override Polaris Alert component styles\n  // See ticket for context: https://sim.amazon.com/issues/EventHorizon-2611\n  .bork-alert {\n    margin-bottom: 1rem;\n    div[class^='awsui_header'],\n    div[class*='awsui_header'] {\n      color: ", " !important;\n    }\n\n    div[class^='awsui_type-info'],\n    div[class*='awsui_type-info'] {\n      border-color: ", " !important;\n      background-color: ", " !important;\n\n      > div[class^='awsui_icon']:first-child {\n        color: ", " !important;\n      }\n    }\n\n    div[class^='awsui_type-success'],\n    div[class*='awsui_type-success'] {\n      border-color: ", " !important;\n      background-color: ", " !important;\n\n      > div[class^='awsui_icon']:first-child {\n        color: ", " !important;\n      }\n    }\n\n    div[class^='awsui_type-error'],\n    div[class*='awsui_type-error'] {\n      border-color: ", " !important;\n      background-color: ", " !important;\n\n      > div[class^='awsui_icon']:first-child {\n        color: ", " !important;\n      }\n    }\n\n    div[class^='awsui_type-warning'],\n    div[class*='awsui_type-warning'] {\n      border-color: ", " !important;\n      background-color: ", " !important;\n\n      > div[class^='awsui_icon']:first-child {\n        color: ", " !important;\n      }\n    }\n\n    &-content {\n      > :first-child {\n        margin-top: 0px;\n      }\n      > :last-child {\n        margin-bottom: 0px;\n      }\n    }\n  }\n\n  // Custom styles to override Polaris Icon component styles\n  // See ticket for context: https://sim.amazon.com/issues/EventHorizon-2611\n  span[class^='awsui_variant-link'].bork-icon,\n  span[class*='awsui_variant-link'].bork-icon {\n    color: ", " !important;\n  }\n\n  span[class^='awsui_variant-error'].bork-icon,\n  span[class*='awsui_variant-error'].bork-icon {\n    color: ", " !important;\n  }\n\n  span[class^='awsui_variant-warning'].bork-icon,\n  span[class*='awsui_variant-warning'].bork-icon {\n    color: ", " !important;\n  }\n\n  span[class^='awsui_variant-success'].bork-icon,\n  span[class*='awsui_variant-success'].bork-icon {\n    color: ", " !important;\n  }\n\n  span[class^='awsui_variant-subtle'].bork-icon,\n  span[class*='awsui_variant-subtle'].bork-icon {\n    color: ", " !important;\n  }\n\n  span[class^='awsui_variant-inverted'].bork-icon,\n  span[class*='awsui_variant-inverted'].bork-icon {\n    color: ", " !important;\n  }\n\n  ", "\n"])), props => props.$padding ? 'padding: 2rem' : null, _ref => {
  let {
    theme
  } = _ref;
  return theme.background;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colorTextDefault;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colorScheme;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colorTextHeading;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colorTextDefault;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colorTextLink;
}, _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.colorTextLinkHover;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colorTextSelected;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.blockquote.bqBorderColor;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.blockquote.bqBgColor;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.table.tbodyBgColor;
}, _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.table.thBorderColor;
}, _ref13 => {
  let {
    theme
  } = _ref13;
  return theme.table.thBgColor;
}, _ref14 => {
  let {
    theme
  } = _ref14;
  return theme.table.thBorderColor;
}, _ref15 => {
  let {
    theme
  } = _ref15;
  return theme.table.thFontColor;
}, _ref16 => {
  let {
    theme
  } = _ref16;
  return theme.colorTextDefault;
}, _ref17 => {
  let {
    theme
  } = _ref17;
  return theme.table.thBorderColor;
}, _ref18 => {
  let {
    theme
  } = _ref18;
  return theme.background;
}, _ref19 => {
  let {
    theme
  } = _ref19;
  return theme.colorTextDefault;
}, _ref20 => {
  let {
    theme
  } = _ref20;
  return theme.colorKeyboardBorder;
}, _ref21 => {
  let {
    theme
  } = _ref21;
  return theme.colorKeyboardBorder;
}, _ref22 => {
  let {
    theme
  } = _ref22;
  return theme.colorKeyboardBorder;
}, _ref23 => {
  let {
    theme
  } = _ref23;
  return theme.colorKeyboardBorder;
}, _ref24 => {
  let {
    theme
  } = _ref24;
  return theme.expandableSection.borderRadius;
}, _ref25 => {
  let {
    theme
  } = _ref25;
  return theme.expandableSection.borderRadius;
}, _ref26 => {
  let {
    theme
  } = _ref26;
  return theme.expandableSection.containerBgColor;
}, _ref27 => {
  let {
    theme
  } = _ref27;
  return theme.expandableSection.borderRadius;
}, _ref28 => {
  let {
    theme
  } = _ref28;
  return theme.expandableSection.triggerTextColor;
}, _ref29 => {
  let {
    theme
  } = _ref29;
  return theme.expandableSection.triggerTextHoverColor;
}, _ref30 => {
  let {
    theme
  } = _ref30;
  return theme.expandableSection.triggerBorderColor;
}, _ref31 => {
  let {
    theme
  } = _ref31;
  return theme.expandableSection.contentBgColor;
}, _ref32 => {
  let {
    theme
  } = _ref32;
  return theme.expandableSection.containerBorderTop;
}, _ref33 => {
  let {
    theme
  } = _ref33;
  return theme.expandableSection.containerBoxShadow;
}, _ref34 => {
  let {
    theme
  } = _ref34;
  return theme.expandableSection.marginBottom;
}, _ref35 => {
  let {
    theme
  } = _ref35;
  return theme.expandableSection.contentBgColor;
}, _ref36 => {
  let {
    theme
  } = _ref36;
  return theme.expandableSection.borderRadius;
}, _ref37 => {
  let {
    theme
  } = _ref37;
  return theme.expandableSection.borderRadius;
}, _ref38 => {
  let {
    theme
  } = _ref38;
  return theme.expandableSection.triggerBorderColor;
}, _ref39 => {
  let {
    theme
  } = _ref39;
  return theme.colorTextHeading;
}, _ref40 => {
  let {
    theme
  } = _ref40;
  return theme.alert.infoBorderColor;
}, _ref41 => {
  let {
    theme
  } = _ref41;
  return theme.alert.infoBgColor;
}, _ref42 => {
  let {
    theme
  } = _ref42;
  return theme.alert.infoIconColor;
}, _ref43 => {
  let {
    theme
  } = _ref43;
  return theme.alert.successBorderColor;
}, _ref44 => {
  let {
    theme
  } = _ref44;
  return theme.alert.successBgColor;
}, _ref45 => {
  let {
    theme
  } = _ref45;
  return theme.alert.successIconColor;
}, _ref46 => {
  let {
    theme
  } = _ref46;
  return theme.alert.errorBorderColor;
}, _ref47 => {
  let {
    theme
  } = _ref47;
  return theme.alert.errorBgColor;
}, _ref48 => {
  let {
    theme
  } = _ref48;
  return theme.alert.errorIconColor;
}, _ref49 => {
  let {
    theme
  } = _ref49;
  return theme.alert.warningBorderColor;
}, _ref50 => {
  let {
    theme
  } = _ref50;
  return theme.alert.warningBgColor;
}, _ref51 => {
  let {
    theme
  } = _ref51;
  return theme.alert.warningIconColor;
}, _ref52 => {
  let {
    theme
  } = _ref52;
  return theme.icon.linkColor;
}, _ref53 => {
  let {
    theme
  } = _ref53;
  return theme.icon.errorColor;
}, _ref54 => {
  let {
    theme
  } = _ref54;
  return theme.icon.warningColor;
}, _ref55 => {
  let {
    theme
  } = _ref55;
  return theme.icon.successColor;
}, _ref56 => {
  let {
    theme
  } = _ref56;
  return theme.icon.subtleColor;
}, _ref57 => {
  let {
    theme
  } = _ref57;
  return theme.icon.invertedColor;
}, _ref58 => {
  let {
    theme
  } = _ref58;
  return theme.colorScheme === 'light' ? lightCodeTheme : darkCodeTheme;
});

export { MarkdownContent };
